import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=8188122c&scoped=true"
import script from "./CalendarItem.vue?vue&type=script&lang=js"
export * from "./CalendarItem.vue?vue&type=script&lang=js"
import style0 from "./CalendarItem.vue?vue&type=style&index=0&id=8188122c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8188122c",
  null
  
)

export default component.exports